// util/formatColumnValue.ts
import { StatsTableColumn } from '../enum/TableColumn';
import { NUMBER_FORMAT_LOCALES } from '../constant/constants';
import { numberFormatter } from './numberFormatter';

const COUNT_COLUMNS = [
  StatsTableColumn.NUMBER_OF_DELETED_TICKETS,
  StatsTableColumn.NUMBER_OF_PAY_IN_TICKETS,
  StatsTableColumn.NUMBER_OF_PAY_OUT_TICKETS,
];

/**
 * Formats a raw cell/footer value for display, based on the
 * semantics of its column:
 *  - ticket-count columns are shown as plain strings (no locale formatting)
 *  - everything else is passed through numberFormatter IF a format
 *    is provided; otherwise the raw value is returned as-is
 *    (used by callers that intentionally skip locale formatting, e.g. TableBody)
 *
 * Used by TableBody, ExpandSum, and ViewPerCurrency so the
 */
export const formatColumnValue = (
  column: string,
  value: number | string,
  format?: keyof typeof NUMBER_FORMAT_LOCALES,
): string | number => {
  if (COUNT_COLUMNS.includes(column as StatsTableColumn)) {
    return value.toString();
  }

  return format ? numberFormatter(Number(value), format) : value;
};
